import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.scss'
import './styles/index.css'
import './mapboxhack'
import App from './App'
import reportWebVitals from './reportWebVitals'
import rjLogger from 'react-rocketjump/logger'

rjLogger()

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
